import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Toaster } from "@/components/ui/sonner";

// Aggressively remove Emergent branding badge
const removeBranding = () => {
  try {
    // Remove by ID
    const badge = document.getElementById('emergent-badge');
    if (badge) {
      badge.remove();
      console.log('Removed emergent-badge by ID');
    }
    
    // Remove all links to emergent.sh
    document.querySelectorAll('a[href*="emergent"]').forEach(el => {
      el.remove();
      console.log('Removed emergent link');
    });
    
    // Remove any elements with emergent branding text
    document.querySelectorAll('*').forEach(el => {
      if (el.textContent && (
        el.textContent.includes('Made with Emergent') ||
        el.textContent.includes('Emergent') && el.tagName === 'A'
      )) {
        el.remove();
        console.log('Removed element with emergent text');
      }
    });
  } catch (e) {
    console.error('Error removing branding:', e);
  }
};

// Run immediately
removeBranding();

// Run after DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', removeBranding);
} else {
  removeBranding();
}

// Use MutationObserver to watch for dynamically added badges
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) { // Element node
        if (node.id === 'emergent-badge' || 
            (node.tagName === 'A' && node.href && node.href.includes('emergent'))) {
          node.remove();
          console.log('MutationObserver removed badge');
        }
      }
    });
  });
});

// Start observing
observer.observe(document.body || document.documentElement, {
  childList: true,
  subtree: true
});

// Also run periodically as a fallback
setInterval(removeBranding, 500);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="bottom-right" />
  </React.StrictMode>,
);
